import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
//import { deleteBanner, editBanner, fetchBannerList, openGlobalPopup, updateBannerStatus } from '../../redux/action';
import MobileFilterCard from "../common/MobileFilterCard";
import ConfirmBox from "../Popup/ConfirmBox";
import "./BannerMobileList.css"; 
import { fetchBanner, deleteBanner ,editBanner, openGlobalPopup, updateBannerStatus} from '../../redux/action';
import { useTranslation } from "react-i18next";
import EmptyScreen from "../common/EmptyScreen";

function BannerMobileList({ onEdit }) {
  const { t } = useTranslation();
  const [deleteId, setDeleteId] = useState('');
  const [validationError, setValidationError] = useState('');
  const bannersObj = useSelector((state) => state.admin?.banners) || [];
  const banners = Array.isArray(bannersObj) ? bannersObj : Object.values(bannersObj);

  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(fetchBanner());
  }, [dispatch]);

  const filteredBanners = banners.filter((banner) =>
    banner.bannerName.toLowerCase().includes(search.toLowerCase())
  );

  const activeCount = banners.filter(b => b.displayOnMenu).length;

  const handleToggleStatus = (banner) => {
    if (!banner.displayOnMenu && activeCount >= 4) {
      setValidationError("Maximum 4 active banners allowed on QR Portal!");
      return;
    }
    setValidationError('');
    dispatch(updateBannerStatus({
      bannerId: banner.bannerId,
      displayOnMenu: !banner.displayOnMenu,
      previousDisplayOnMenu: banner.displayOnMenu,
    }));
  };

  const handleDelete = (bannerId) => {
    setDeleteId(bannerId);
    dispatch(openGlobalPopup("confirm-box"));
  };

    const handleEdit = (banner) => {
      dispatch(editBanner(banner));
      onEdit();
    };

  return (
    <div className="category-container">
      {validationError && <p style={{ color: "var(--ui-danger-text)", fontSize: '12px', margin: '4px 0' }}>{validationError}</p>}

      <MobileFilterCard
        label={t("Search banners")}
        hint={t("Find a banner by name.")}
        placeholder={t("Search banner by name...")}
        search={search}
        setSearch={setSearch}
        countText={`${filteredBanners.length} ${t("banners")}${search.trim() ? ` ${t("found")}` : ""}`}
        statusText={`${t("Live")}: ${activeCount}/4`}
      />

      {filteredBanners.length === 0 ? (
        <EmptyScreen
          compact
          message={banners.length ? "No matching banners found." : "No promotional banners yet."}
          subText={banners.length ? "Clear the search to view all banners." : "Upload a banner to promote offers on the customer menu."}
          actionLabel={banners.length && search ? "Clear search" : undefined}
          onAction={banners.length && search ? () => setSearch("") : undefined}
        />
      ) : (
        <ul className="card-list">
          {filteredBanners.map((banner) => (
            <li className={`category-card banner-mobile-card ${banner.isActive ? "mobile-active-border" : ""}`} key={banner.bannerId}>
              
              <div className="banner-mobile-header">
                <label className="banner-checkbox-label">
                  <input 
                    type="checkbox" 
                    checked={banner.displayOnMenu} 
                    onChange={() => handleToggleStatus(banner)}
                  />
                  <span>{banner.displayOnMenu ? t("Active Live") : t("Hidden Mode")}</span>
                </label>
                  <span class="edit-icon link-btn" title="Edit" aria-label="Edit" onClick={() => handleEdit(banner)}>✎</span>
              </div>

              <div className="card-body banner-mobile-body">
                <div className="banner-mobile-preview-box">
                  <img src={banner.bannerImage} alt={banner.bannerName} />
                </div>
              </div>

              <div className="card-actions">
                <button className="delete-cat" onClick={() => handleDelete(banner.bannerId)}>
                 ✖ Delete 
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}

      <ConfirmBox
        variant="delete"
        title={"Are you sure you want to delete this promotional banner?"}
        onConfirm={() => {
          dispatch(deleteBanner(deleteId));
        }}
        onCancel={() => {
          setDeleteId('');
        }}
      />
    </div>
  );
}

export default BannerMobileList;
